/* ==========================================================================
 * custom-media-transition.js — Chuyen anh san pham MUOT (truot ngang + mo)
 * thay vi nhap nhay. Store dung hide_variants (moi mau = 1 anh) nen doi mau
 * la thao tac SWAP anh chinh -> boc trong View Transitions API cho muot.
 *
 * Boc 2 cho:
 *  - product-info.updateMedia  : khi doi variant/mau (them/xoa/doi anh chinh)
 *  - media-gallery.setActiveMedia : khi click thumbnail (san pham nhieu anh)
 * Guard vtActive chan long View Transition (updateMedia goi setActiveMedia ben trong).
 * Slide dinh nghia o custom-product-layout.css muc 8 (::view-transition-*).
 *
 * An toan: khong ho tro startViewTransition / prefers-reduced-motion -> goi
 * thang ham goc (hanh vi cu, khong loi).
 * ========================================================================== */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var vtActive = false;

  function enabled() {
    // Mac dinh bat neu chua co config (vd section chua render co); tat khi setting = false
    return !window.medoMediaTransition || window.medoMediaTransition.enabled !== false;
  }

  function withVT(run) {
    if (typeof document.startViewTransition !== 'function' || reduce.matches || vtActive || !enabled()) {
      run();
      return;
    }
    vtActive = true;
    var t;
    try {
      t = document.startViewTransition(run);
    } catch (e) {
      vtActive = false;
      run();
      return;
    }
    if (t && t.finished && t.finished.finally) {
      t.finished.finally(function () { vtActive = false; });
    } else {
      vtActive = false;
    }
  }

  function patchGallery() {
    var G = customElements.get('media-gallery');
    if (!G || G.prototype.__vtPatched) return;
    G.prototype.__vtPatched = true;
    var orig = G.prototype.setActiveMedia;
    if (typeof orig !== 'function') return;
    G.prototype.setActiveMedia = function (mediaId) {
      var self = this, args = arguments;
      // Bam lai dung anh dang active -> khong can animate
      var viewer = self.elements && self.elements.viewer;
      var cur = viewer && viewer.querySelector('[data-media-id].is-active');
      if (cur && cur.dataset.mediaId === String(mediaId)) {
        return orig.apply(self, args);
      }
      withVT(function () { orig.apply(self, args); });
    };
  }

  function patchInfo() {
    var P = customElements.get('product-info');
    if (!P || P.prototype.__vtPatched) return;
    P.prototype.__vtPatched = true;
    var orig = P.prototype.updateMedia;
    if (typeof orig !== 'function') return;
    P.prototype.updateMedia = function () {
      var self = this, args = arguments;
      withVT(function () { orig.apply(self, args); });
    };
  }

  if (window.customElements) {
    patchGallery();
    patchInfo();
    customElements.whenDefined('media-gallery').then(patchGallery);
    customElements.whenDefined('product-info').then(patchInfo);
  }
})();
